import {Component, inject, Signal, signal, viewChild, WritableSignal} from '@angular/core';
import {MatTab, MatTabContent, MatTabGroup, MatTabLabel} from '@angular/material/tabs';
import {TabContentComponent} from './tab/tab-content.component';
import {MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {EsvgFiles} from 'frontier/nucleus';
import {TabsService} from '../tabs/tabs.service';
import {ITab} from 'frontier/browserkit/src/lib/components/home-without-gl/tabs/tab.interface';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {TabActivatedDirective} from 'frontier/browserkit/src/lib/directives/tab-activated.directive';
import {CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray} from '@angular/cdk/drag-drop';

@Component({
  selector: 'lib-tabs',
  standalone: true,
  imports: [
    MatTab,
    MatTabContent,
    MatTabGroup,
    TabContentComponent,
    MatTabLabel,
    MatIconButton,
    MatIcon,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    TabActivatedDirective,
    CdkDropList,
    CdkDrag,
  ],
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss'
})
export class TabsComponent {
  protected readonly EsvgFiles: typeof EsvgFiles = EsvgFiles;
  private _tabsService: TabsService = inject(TabsService);
  private _menuTrigger: Signal<MatMenuTrigger> = viewChild(MatMenuTrigger);

  selectedIndex: Signal<number> = this._tabsService.selectedTabIndex;
  tabs: Signal<ITab[]> = this._tabsService.tabs;
  animationDuration: WritableSignal<number> = this._tabsService.animationDuration;
  position: WritableSignal<{
    x: number;
    y: number;
  }> = signal({
    x: 0,
    y: 0,
  });
  menuTab: WritableSignal<ITab> = signal<ITab | null>(null);

  removeTab(index: number, evt: MouseEvent): void {
    // Ignore right click (2), since this is handled via (contextmenu).
    if (evt.button === 2) {
      return;
    }

    evt.stopPropagation();
    evt.preventDefault();
    this._tabsService.closeTabByIndex(index);
  }

  onTabContextMenu(evt: MouseEvent, tab: ITab): void {
    evt.stopPropagation();
    evt.preventDefault();
    this.menuTab.set(tab);
    this.position.set({x: evt.clientX, y: evt.clientY});
    this._menuTrigger().openMenu();
  }

  closeAllTabs(): void {
    this._tabsService.closeAllTabs();
  }

  closeAllTabsExcept(): void {
    this._tabsService.closeAllTabsExcept(this.menuTab());
  }

  onSelectedIndexChange(idx: number): void {
    this._tabsService.selectTabByIndex(idx);
  }

  drop(event: CdkDragDrop<string[]>): void {
    const tabsArray: ITab[] = [...this.tabs()];
    moveItemInArray(tabsArray, event.previousIndex, event.currentIndex);
    this._tabsService.updateTabsOrder(tabsArray);
  }
}
